<app-tab-layout [loading]="loading()" [error]="error">
  @if (initialized()) {
    <app-api-table
      [name]="name"
      [endpoint]="endpoint"
      [hasChartView]="hasChartView"
      [skipDateRange]="skipDateRange"
      [defaultSort]="defaultSort"
    />
  }
</app-tab-layout>
